import {RecruiterNotificationList} from "./RecruiterNotificationList";
import {RecruiterNotificationEdit} from "./RecruiterNotificationEdit";
import {RecruiterNotificationCreate} from "./RecruiterNotificationCreate";

export default {
    list: RecruiterNotificationList,
    create: RecruiterNotificationCreate,
    edit: RecruiterNotificationEdit
};
